module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('strong', [_c('div', [_vm._v("\n          Random episode from season:\n      ")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.getAnyRandomEpisode
    }
  }, [_vm._v("Any")])]), _vm._v(" "), _vm._l((_vm.epData), function(season) {
    return _c('span', {
      key: season.title
    }, [_vm._v("\n         \n        "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.getSeasonRandomEpisode(season.airedSeason)
        }
      }
    }, [_vm._v("\n          " + _vm._s(season.airedSeason) + "\n        ")])])
  })], 2)]), _vm._v(" "), _c('div', [_c('strong', [_c('div', [_vm._v("\n          Browse episodes from season:\n      ")]), _vm._v(" "), _vm._l((_vm.epData), function(season) {
    return _c('span', {
      key: season.title
    }, [_vm._v("\n         \n        "), _c('router-link', {
      attrs: {
        "to": {
          path: '/Browse/Season/' + season.airedSeason
        }
      }
    }, [_vm._v("\n          " + _vm._s(season.airedSeason) + "\n        ")])], 1)
  })], 2)]), _vm._v(" "), _c('div', [_c('strong', [_c('router-link', {
    attrs: {
      "to": "/DrinkingRules"
    }
  }, [_vm._v("Drinking Rules")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d31596c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 36
// module chunks = 0